import axios, {AxiosResponse} from 'axios'
import {ContentType} from '../preact-components/utils/contentType'
import globals from '../utils/globals'

export default class PreviewService {
  public static generatePreviewUrl = async (topicId: number, contentType: ContentType): Promise<string> => {
    try {
      const response: AxiosResponse = await axios.post('/preview/generateToken', {topicId, contentType})
      const {token} = response.data

      return `${globals(('communityUrl'))}/${contentType}/${topicId}?t=${token}`
    } catch (e) {
      throw e
    }
  }

  public static setVisibility = async (topicId: number, contentType: ContentType, isPublic: boolean): Promise<AxiosResponse> => {
    try {
      return axios.post(`/community/api/${contentType}s/${topicId}/togglePreview`, {'public': isPublic})
    } catch (e) {
      throw e
    }
  }
}
